import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { presetHoy, presetMes } from "@/lib/daterange";

/**
 * Reusable Desde/Hasta filter with Hoy/Mes shortcut buttons.
 * Props: desde, hasta, setDesde, setHasta, testidPrefix, showClear
 */
export default function DateRangeFilter({ desde, hasta, setDesde, setHasta, testidPrefix = "date", showClear = true }) {
  return (
    <div className="flex flex-wrap items-end gap-2">
      <div>
        <Label className="text-[10px] uppercase tracking-widest">Desde</Label>
        <Input type="date" value={desde || ""} onChange={(e) => setDesde(e.target.value)} data-testid={`${testidPrefix}-desde`} />
      </div>
      <div>
        <Label className="text-[10px] uppercase tracking-widest">Hasta</Label>
        <Input type="date" value={hasta || ""} onChange={(e) => setHasta(e.target.value)} data-testid={`${testidPrefix}-hasta`} />
      </div>
      <div className="flex gap-1">
        <Button
          size="sm" variant="outline"
          onClick={() => { const p = presetHoy(); setDesde(p.desde); setHasta(p.hasta); }}
          data-testid={`${testidPrefix}-hoy`}
        >Hoy</Button>
        <Button
          size="sm" variant="outline"
          onClick={() => { const p = presetMes(); setDesde(p.desde); setHasta(p.hasta); }}
          data-testid={`${testidPrefix}-mes`}
        >Mes</Button>
        {showClear && (desde || hasta) && (
          <Button
            size="sm" variant="ghost"
            onClick={() => { setDesde(""); setHasta(""); }}
            data-testid={`${testidPrefix}-clear`}
          >Limpiar</Button>
        )}
      </div>
    </div>
  );
}
